export default function CaretDown({
    style,
    fill="#262626",
}){
    return <svg style={style} width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.75415 0.599609L4.75415 6.99961L0.75415 0.599609L8.75415 0.599609Z" fill={fill} />
    </svg>       
}